import { Card, Spin, Tag } from "antd";
import React, { useEffect, useState } from "react";
import Base from "../../Config/Base";
import { Footer } from "../footer/footer";
import { useLocation } from "react-router-dom";
import { API_BASE_CRM_URL } from "../../Config/Config";
import { useNavigate } from "react-router-dom";
const ViewProposal = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);
  const location = useLocation();

  const proposal = location.state?.proposal;
  const [proposalDetails, setProposalDetails] = useState(proposal);

  console.log(proposalDetails, "proposalDetailsssss");
  const [proposalProducts, setProposalProducts] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);

  const getProposalDetails = async () => {
    try {
      setPageLoading(true);

      const response = await fetch(
        `${API_BASE_CRM_URL}proposal/GetProposal/${proposal.id}`,
      );

      const data = await response.json();

      if (data.Proposal) {
        setProposalDetails(data.Proposal);

        const mergedProducts = data.ItemDetails.map((item, index) => ({
          ...item,
          ...(data.RelatedItems[index] || {}),
        }));

        setProposalProducts(mergedProducts);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setPageLoading(false);
    }
  };
  useEffect(() => {
    getProposalDetails();
  }, [proposal]);

  return (
    <Base>
      {pageLoading ? (
        <div className="text-center mt-5">
          <Spin size="large" />
        </div>
      ) : (
        <>
          <Card className="shadow-sm border-0 mb-3">
            <div className="d-flex justify-content-between">
              <div>
                <h5>{proposalDetails.subject}</h5>

                <small className="text-muted">
                  <i className="fas fa-user me-2"></i>
                  {proposalDetails.proposal_to}
                </small>
              </div>

              <div className="text-end">
                <Tag color="blue">
                  {proposalDetails.status === 1 ? "Open" : "Closed"}
                </Tag>

                <br />

                <small className="text-muted">
                  <i className="fas fa-user me-2"></i>
                  {proposalDetails.AddedByName}
                </small>
              </div>
            </div>
          </Card>

          <Card className="shadow-sm border-0 mb-3">
            <h6>
              <i className="fas fa-file-alt text-primary me-2"></i>
              Proposal Description
            </h6>

            <p
              className="mb-0"
              style={{
                whiteSpace: "pre-line",
              }}
            >
              {proposalDetails.content}
            </p>
          </Card>

          <Card className="shadow-sm border-0 mb-3">
            <h6>
              <i className="fas fa-address-card text-success me-2"></i>
              Customer Details
            </h6>

            <div className="row">
              <div className="col-6 mb-2">
                <strong>Name</strong>

                <br />

                {proposalDetails.proposal_to}
              </div>

              <div className="col-6 mb-2">
                <strong>Email</strong>

                <br />

                {proposalDetails.email}
              </div>

              <div className="col-6 mb-2">
                <strong>Phone</strong>

                <br />

                {proposalDetails.phone}
              </div>

              <div className="col-6 mb-2">
                <strong>City</strong>

                <br />

                {proposalDetails.city}
              </div>

              <div className="col-6 mb-2">
                <strong>State</strong>

                <br />

                {proposalDetails.state}
              </div>

              <div className="col-6 mb-2">
                <strong>ZIP</strong>

                <br />

                {proposalDetails.zip}
              </div>

              <div className="col-12">
                <strong>Address</strong>

                <br />

                {proposalDetails.address}
              </div>
            </div>
          </Card>
          {proposalProducts.map((product, index) => {
            const amount = Number(product.qty) * Number(product.rate);

            return (
              <Card key={index} className="shadow-sm border-0 mb-3">
                <div className="d-flex justify-content-between">
                  <div>
                    <h6>{product.description}</h6>

                    <small className="text-muted">
                      SKU : {product.sku_code || "-"}
                    </small>

                    <br />

                    <small className="text-muted">Unit : {product.unit}</small>
                  </div>

                  <div className="text-end">
                    <div className="fw-bold">
                      ₹{Number(product.rate).toLocaleString()}
                    </div>

                    <small className="text-muted">Per Unit</small>
                  </div>
                </div>

                {product.long_description && (
                  <>
                    <hr />

                    <div
                      className="text-muted"
                      style={{ whiteSpace: "pre-line" }}
                    >
                      {product.long_description}
                    </div>
                  </>
                )}

                <hr />

                <div className="row text-center">
                  <div className="col">
                    <small className="text-muted d-block">Qty</small>

                    <strong>{product.qty}</strong>
                  </div>

                  <div className="col">
                    <small className="text-muted d-block">Unit</small>

                    <strong>{product.unit}</strong>
                  </div>

                  <div className="col">
                    <small className="text-muted d-block">Amount</small>

                    <strong>₹{amount.toLocaleString()}</strong>
                  </div>
                </div>
              </Card>
            );
          })}

          <Card className="shadow-sm border-0">
            <h6 className="mb-3">Proposal Summary</h6>

            <div className="d-flex justify-content-between mb-2">
              <span>Subtotal</span>

              <strong>
                ₹{Number(proposalDetails.subtotal).toLocaleString()}
              </strong>
            </div>

            <div className="d-flex justify-content-between mb-2">
              <span>Tax</span>

              <strong>
                ₹{Number(proposalDetails.total_tax).toLocaleString()}
              </strong>
            </div>

            <div className="d-flex justify-content-between mb-2">
              <span>Adjustment</span>

              <strong>
                ₹{Number(proposalDetails.adjustment).toLocaleString()}
              </strong>
            </div>

            <hr />

            <div className="d-flex justify-content-between">
              <h5>Total</h5>

              <h4 className="text-success">
                ₹{Number(proposalDetails.total).toLocaleString()}
              </h4>
            </div>
          </Card>
        </>
      )}

      <Footer />
    </Base>
  );
};

export default ViewProposal;
